import {
  Box,
  IconButton,
  styled,
} from "@mui/material";
import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  APP_HOVER_COLOR,
  BORDER_COLOR,
  FONT_FAMILY,
  TEXT_COLOR,
} from "../../theme";

export const styles = {
  versionScrollContainer: {
    maxHeight: "40vh",
    overflowY: "scroll",
    scrollbarWidth: "none",
    marginTop: "10px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  } as const,
  linkNotifyContainer: {
    border: `1px solid ${BORDER_COLOR}`,
    backgroundColor: "#10222e",
    borderRadius: "var(--radius-xl, 12px)",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    flexWrap: "wrap",
  } as const,
  linkButtonsContainer: {
    width: "30%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    alignItems: "center",
  } as const,
  linkNotifyIconContainer: {
    width: "30%",
    minWidth: "200px",
    paddingLeft: "20px",
    display: "flex",
    alignItems: "center",
  } as const,
  reorderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  bigScreenScrollC: {
    overflowY: "scroll",
    scrollbarWidth: "none",
    paddingBottom: "112px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    borderBottomLeftRadius: "var(--radius-xl, 12px)",
    borderBottomRightRadius: "var(--radius-xl, 12px)",
  } as const,
  mainScrollC: {
    display: "flex",
    height: "calc(100vh - 130px)",
    overflowY: "scroll",
    scrollbarWidth: "none",
    paddingBottom: "112px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  } as const,
  accordion: {
    borderBottom: `1px solid ${BORDER_COLOR}`,
    boxShadow: "none",
    marginTop: 0,
    "&:before": {
      display: "none",
    }
  } as const,
  genreTag: {
    fontSize: "13px",
    marginLeft: "10px",
    marginBottom: 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "200px",
  } as const,
  contributorsContainer: {
    display: "flex",
    padding: "5px",
    gap: "10px",
    alignItems: "center",
    width: "100px",
  } as const,
  isLoadingContainer: {
    height: "250px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#1F242F",
  } as const,
  checkBox: {
    color: "var(--Colors-Border-border-primary, #333741)",
    borderRadius: "var(--spacing-sm, 6px)",
  } as const,
  trackInformationBox: {
    minWidth: "150px",
    fontSize: "14px",
    marginLeft: 1,
  } as const,
  makePrimaryButton: {
    width: "160px",
    textTransform: "none",
    color: TEXT_COLOR,
    fontSize: "14px",
  } as const,
  button: {
    borderRadius: "var(--radius-md, 8px)",
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  filterButton: {
    borderRadius: "var(--radius-md, 8px)",
    height: "55px",
    color: TEXT_COLOR,
    fontWeight: "bold",
    border: `1px solid ${BORDER_COLOR}`,
    background:
      "var(--Component-colors-Components-Buttons-Secondary-button-secondary-bg, #161B26)",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    textTransform: "none",
    fontSize: "14px",
    paddingRight: "20px",
    "&:hover": {
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  } as const,
  sizeIconContainer: {
    width: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  filterAndSortValueContainer: {
    padding: "2px",
    paddingLeft: "10px",
    border: "1px solid gray",
    borderRadius: "10px",
  } as const,
  closeIcon: {
    fontSize: "16px"
  } as const,
  image: {
    width: "55px",
    minWidth: "55px",
    height: "55px",
    borderRadius: "var(--radius-xs, 4px)",
  } as const,
  loadingContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "15px",
  } as const,
  checkedTracksDetailsContainer: {
    width: "250px",
    display: "flex",
    justifyContent: "flex-end",
  } as const,
  checkTrackDetailsSwitchContainer: {
    border: "1px solid gray",
    borderRadius: "10px",
    width: "280px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "40px",
  } as const,
  checkedFilesDetailsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: "10px",
    padding: "10px"
  } as const,
  controllersContainer: {
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    height: "auto",
  } as const,
  filtersContainer: {
    display: "flex",
    margin: "9px 0px",
    flexWrap: "wrap",
    justifyContent: "space-between",
  } as const,
  tracksCountSwitchContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap"
  } as const,
  fileCountContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  } as const,
  pauseIcon: {
    width: "20px",
    height: "20px",
    filter: "invert(100%)",
  } as const,
  audioMetaData: {
    marginLeft: "10px",
    fontSize: "13px"
  } as const,
  statusNoteContainer: {
    minWidth: "180px",
    marginLeft: -1.5
  } as const,
  filterAndSortMenuContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: '5px',
    alignItems: "center",
  } as const,
  noteButton: {
    borderRadius: "var(--radius-full, 9999px)",
    textTransform: "none",
    width: "auto",
    display: "flex",
    justifyContent: "left",
  } as const,
  noteContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "left",
    backgroundColor: "#511C10",
    borderRadius: "var(--radius-full, 9999px)",
    padding: "0px 10px 0px 10px",
    color: "#F7B27A",
    cursor: "pointer",
    flexDirection: "column",
  } as const,
  masteringNoteContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "left",
    border: "1px solid #2C1C5F",
    backgroundColor: "#2C1C5F",
    borderRadius: "var(--radius-full, 9999px)",
    padding: "0px 10px 0px 10px",
    color: "#D6BBFB",
    cursor: "pointer",
    flexDirection: "column",
  } as const,
  mixingNoteContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "left",
    border: "1px solid #4E0D30",
    backgroundColor: "#4E0D30",
    borderRadius: "var(--radius-full, 9999px)",
    padding: "0px 10px 0px 10px",
    color: "#FAA7E0",
    cursor: "pointer",
    flexDirection: "column",
  } as const,
  typography: {
    fontSize: "14px",
  } as const,
  unspecifiedNoteContainer: {
    display: "flex",
    backgroundColor: "#161B26",
    borderRadius: "var(--radius-full, 9999px)",
    color: "#CECFD2",
    cursor: "pointer",
    padding: "0px 10px 0px 10px",
    paddingTop: "2px",
    paddingBottom: "2px",
  } as const,
  publishingNoteContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    border: "1px solid #053321",
    backgroundColor: "#053321",
    borderRadius: "var(--radius-full, 9999px)",
    padding: "0px 10px 0px 10px",
    color: "#75E0A7",
    cursor: "pointer",
    flexDirection: "column",
  } as const,
  completeNoteContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    border: "1px solid #102A56",
    backgroundColor: "#102A56",
    borderRadius: "var(--radius-full, 9999px)",
    padding: "0px 10px 0px 10px",
    color: "#84CAFF",
    cursor: "pointer",
    flexDirection: "column",
  } as const,
  preProductionNoteContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    border: "1px solid #B58900",
    backgroundColor: "#B58900",
    borderRadius: "var(--radius-full, 9999px)",
    padding: "0px 10px 0px 10px",
    color: "#FFFFFF",
    cursor: "pointer",
    flexDirection: "column",
  } as const,
  outerNoteContainer: {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
  } as const,
  noteMenuContainer: {
    backgroundColor: APP_BACKGROUND_COLOR,
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "15px",
    justifyContent: "flex-start",
  } as const,
  emptyTracksContainer: {
    height: "20vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  versionLabel: {
    fontSize: "14px",
    marginLeft: "10px",
    paddingLeft: "8px",
    maxWidth: "180px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  } as const,
  foldersContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    maxHeight: "100px",
    marginBottom: "10px",
    overflowY: "auto",
    scrollbarWidth: "auto",
    scrollbarColor: `${APP_COLOR} transparent`,
    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-track": {
      background: "red",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "gray",
      borderRadius: "10px",
      border: "1px solid gray",
    },
  } as const,
  folderContainerMobile: {
    justifyContent: "left",
    alignItems: "center",
    height: "100px",
    padding: "0px 2px",
  } as const,
  folderMainContainer: {
    display: "flex",
    alignItems: "center",
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: "6px",
  } as const,
  folderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
    minWidth: "125px",
    width: "125px",
    maxWidth: "160px",
    padding: "5px",
    borderRadius: "5px",
    cursor: "pointer",
  } as const,
  textEllipsis: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    flex: 1,
  } as const,
  commentsContainer: {
    backgroundColor: APP_BACKGROUND_COLOR,
    margin: 0,
    padding: "10px",
    width: "350px",
    maxHeight: "250px",
    overflow: "scroll",
    scrollbarWidth: "none",
  } as const,
  commentContainer: {
    padding: "10px",
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: "10px",
    marginBottom: "10px",
  } as const,
  timeStampAndUserContainer: {
    display: "flex",
    justifyContent: "space-between",
  } as const,
  commentAndTimeContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  } as const,
  trackSlider: {
    marginBottom: 2,
    color: "white",
    marginTop: "15px"
  } as const,
};

export const CustomTracksScrollingContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    maxHeight: "100vh",
    height: "120vh",
  },
}));

export const CustomContributorsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "5px",
  gap: "10px",
  alignItems: "center",
  width: "100px",
  fontSize: "14px",
  [theme.breakpoints.down("md")]: {
    marginRight: "10px",
  },
}));

export const CustomActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  fontSize: "14px",
  alignItems: "center",
  width: "110px",
  justifyContent: "space-between",
  [theme.breakpoints.down("lg")]: {
    gap: "10px",
    width: "95%",
    justifyContent: "space-between",
    margin: "0px 20px 0px 20px",
  },
}));

export const CustomVersionsCountContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "5px",
  minWidth: "90px",
  alignItems: "center",
  fontSize: "14px",
  marginLeft: "10px",
  [theme.breakpoints.down("md")]: {
    marginLeft: "20px",
  },
}));

export const CustomTrackListTitle = styled(Box)(({ theme }) => ({
  marginLeft: "10px",
  fontWeight: "bold",
  fontSize: "14px",
  color: "white",
  display: "flex",
  maxWidth: "10vw",
  [theme.breakpoints.down("xl")]: {
    maxWidth: "10vw",
  },
  [theme.breakpoints.down("md")]: {
    maxWidth: "100px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

export const CustomTrackTList = styled(Box)(({ theme }) => ({
  backgroundColor: APP_BACKGROUND_COLOR,
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  padding: "2px 0px 2px 0px",
  borderBottom: "1px solid #26292B",
  borderTopLeftRadius: "var(--radius-xl, 12px)",
  borderTopRightRadius: "var(--radius-xl, 12px)",
  "&:hover": {
    cursor: "pointer",
  },
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

export const CustomIconButton = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    margin: 1.5,
    padding: 0,
  },
}));

export const MobileScreenLogoContainer = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("md")]: {
    display: "flex",
    justifyContent: 'space-between',
    alignItems: 'center'
  },
}));

export const MobileScreenBottomNavigationContainer = styled(Box)(
  ({ theme }) => ({
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "flex",
    },
  })
);

export const CustomTracksListContainer = styled(Box)(({ theme }) => ({
  border: "1px solid #26292B",
  borderBottom: "none",
  borderRadius: "var(--radius-xl, 12px)",
  [theme.breakpoints.down("md")]: {
    border: "none",
  },
}));

export const ViewIconsContainer = styled(Box)(({ theme }) => ({
  width: "100px",
  borderRadius: "5px",
  display: "flex",
  border: `1px solid ${BORDER_COLOR}`,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const DateContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "5px",
  gap: "10px",
  alignItems: "center",
  fontSize: "14px",
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

export const TrackDetailsContainerForAccordion = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  "&:hover": {
    cursor: "pointer",
  },
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    gap: "10px",
    borderRadius: "15px",
  },
}));

export const CustomAccordionSummery = styled(Box)(({ theme }) => ({
  paddingTop: '8px',
  paddingBottom: '8px',
  margin: 0,
  marginBottom: -7,
  [theme.breakpoints.down("lg")]: {
    height: "auto",
  },
}));

export const CustomTracksPageHeadingContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
  marginTop: "12px",
  [theme.breakpoints.down("md")]: {
    marginTop: -2,
  },
}));

export const FilterDetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginTop: "10px",
  marginBottom: "15px",
  gap: "15px",
  [theme.breakpoints.down("md")]: {
    marginTop: "5px",
    marginBottom: "5px",
  },
}));
